export default __webpack_public_path__ + "static/media/color_logo.47cf496d.svg";